import ApiClient from '../../client';
import { createNamespacedDataProviderStore, extendStore } from './dataprovider';

const emptySeating = { hasSeating: false, me: {}, guests: [] };

// The endpoint answers with a single object, not a collection. It is still stored
// through the shared data provider store — wrapped in a one-element array — so the
// dedupe lock and the items.length short-circuit keep working when several
// components on the same page ask for seating at once.
const store = createNamespacedDataProviderStore((setItems) => {
  return ApiClient.getMySeating().then((response) =>
    setItems([response.data ?? emptySeating])
  );
});

export default extendStore(store, {
  getters: {
    getSeating: (state) => state.items[0] ?? emptySeating,
    // False on events with no seating plan at all, which is what keeps the block
    // off the profile of every event that does not do seating.
    hasSeating: (state, getters) => !!getters.getSeating.hasSeating,
    getMySeat: (state, getters) => getters.getSeating.me ?? {},
    getGuestSeats: (state, getters) => getters.getSeating.guests ?? [],
    hasGuests: (state, getters) => getters.getGuestSeats.length > 0
  }
});
